import { render, staticRenderFns } from "./AppointmentNewSpaceCoordinationWrapper.vue?vue&type=template&id=a04d8898"
import script from "./AppointmentNewSpaceCoordinationWrapper.vue?vue&type=script&lang=js"
export * from "./AppointmentNewSpaceCoordinationWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a04d8898')) {
      api.createRecord('a04d8898', component.options)
    } else {
      api.reload('a04d8898', component.options)
    }
    module.hot.accept("./AppointmentNewSpaceCoordinationWrapper.vue?vue&type=template&id=a04d8898", function () {
      api.rerender('a04d8898', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/appointmentManagement/AppointmentNewSpaceCoordinationWrapper.vue"
export default component.exports